<div class="nim__content-area">
  <div class="container">
    <div class="row mt6 mb3">
      <div class="center">
        <svg class="height-6 width-6 fill-brand-core">
          <use xlink:href="./assets/icons/connect-icons.svg#Bad-Gateway"></use>
        </svg>
      </div>
    </div>
    <div class="row">
      <h1 class="h1 bold center">Not Authorized</h1>
    </div>
    <div class="row">
      <h1 class="h3 center mt2">You do not have permission to view the page you have requested.</h1>
    </div>
    <div class="row">
      <p class="h4 center mt3 ml6 mr6 gray-40">The administrator of this application has restricted access to this page. If you believe that you
        should have access
        to this page, please contact your administrator.
      </p>
    </div>
  </div>
</div>

<div class="nim__sidebar">
  <div class="nim__sidebar__top"></div>
  <div class="nim__sidebar__bottom">
  </div>
  <div class="nim__sidebar__global">
    <div nc-global-navigation [isBackEnabled]="false" [isHomeEnabled]="true" [overrideHomeNavigation]="true"
      (homeButtonClicked)="onHomeButtonClicked()"></div>
  </div>
</div>
